<div class="content">
    <div>
        <div class="access-denied-message">
            Access denied<br>
            You need to be a member of an authorized group to access this application.<br>
            Please contact your administrator for access.
        </div>
    </div>
</div>
